import { render, staticRenderFns } from "./DarkModeToggler.vue?vue&type=template&id=1da4ccf2"
import script from "./DarkModeToggler.vue?vue&type=script&lang=js"
export * from "./DarkModeToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports